import { MCPSourceBadges } from '@/components/shared/mcp';
import { StatusDot } from '@/components/shared/StatusDot';
import type { WidgetTableProps } from '@/components/WidgetTable/types';
import { RelativeTimeWithTooltip } from '@/components/shared/RelativeTimeWithTooltip';
import type { ClientType } from '@kirin/api-client/contracts/mcp';

export interface UserUsage {
  userId: string;
  email: string | null;
  name: string | null;
  sources: ClientType[];
  isRunning: boolean;
  lastSeenAt: string;
}

export const COLUMNS: WidgetTableProps<UserUsage>['columns'] = [
  {
    header: 'User',
    id: 'user',
    cell: user => (
      <div>
        <div className="font-medium">{user.name || 'Unknown User'}</div>
        {user.email && (
          <div className="text-sm text-muted-foreground">{user.email}</div>
        )}
      </div>
    ),
  },
  {
    header: 'Sources',
    id: 'sources',
    cell: row => <MCPSourceBadges sources={(row as UserUsage).sources} />,
  },
  {
    header: 'Status',
    id: 'status',
    cell: user => (
      <div className="flex justify-center">
        <StatusDot
          isActive={(user as UserUsage).isRunning}
          activeLabel="Running"
          inactiveLabel="Offline"
          showLabel={true}
        />
      </div>
    ),
  },
  {
    header: 'Last Seen',
    id: 'lastSeen',
    cell: row => <RelativeTimeWithTooltip date={row.lastSeenAt} />,
  },
];
